<template>
  <v-toolbar
    app
    :clipped-left="clipped"
    height="50"
    class="app-navbar white"
    extended
    tabs
  >
    <!-- <v-toolbar-side-icon class="btn-mini-variant" @click.stop="$store.commit('layout/toggleMiniVariant')"></v-toolbar-side-icon>
    <v-toolbar-side-icon class="btn-drawer" @click.stop="$store.commit('layout/toggleDrawer')"></v-toolbar-side-icon> -->
    <router-link to="/declaracion"><span class="icon-flag" :class="{ 'logo': true }"></span> </router-link>
    <v-spacer></v-spacer>
    <!-- muestra el ambiente -->
    <template v-if="enviroment && enviroment != ''">
      <span class="hidden-md-and-down rounded text-center warning-band px-8 py-1">
        <span class="white rounded font-weight-bold px-2 black--text">{{ enviroment }}</span>
      </span>
      <v-spacer></v-spacer>
    </template>
    <!-- <app-lang></app-lang> -->
    <!-- <v-tooltip bottom>
      <v-btn icon @click="fullscreen()" class="btn-fullscreen" slot="activator">
        <v-icon>fullscreen</v-icon>
        <v-icon>fullscreen_exit</v-icon>
      </v-btn>
      <span>Pantalla completa</span>
    </v-tooltip> -->
    <v-tooltip color="secondary" bottom>
      <v-btn icon @click="reload" slot="activator" class="btn-recargar-pagina">
        <v-icon color="secondary">refresh</v-icon>
      </v-btn>
      <span>Actualizar la página</span>
    </v-tooltip>
    <!-- <v-btn icon @click.stop="$store.commit('layout/toggleRightDrawer')">
      <v-icon>notifications</v-icon>
    </v-btn> -->
    <div v-if="tipo_usuario === 'usuario_externo' && habilitar_edicion === true">
    <v-tooltip color="accent" bottom>
      <v-btn icon slot="activator">
        <v-avatar size="36" :class="this.mycolor" @click.stop="dialog = true">
          <v-icon color='accent'>edit</v-icon>
        </v-avatar>
      </v-btn>
 <v-dialog v-model="dialog" scrollable persistent max-width="700px">
  <v-card>
    <v-toolbar dark color="primary">
           <v-toolbar-title>
      <span v-if="this.modificacion.mod_codigo === null"><h4>Modificación de Datos</h4></span>
      <span v-if="this.modificacion.mod_codigo === 1"><h4>Modificación de Datos Personales</h4></span>
      <span v-if="this.modificacion.mod_codigo === 2"><h4>Modificación de Género</h4></span>
      <span v-if="this.modificacion.mod_codigo === 3"><h4>Modificación de Datos Contacto</h4></span>
    </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="salir(1)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar> 
      <v-card-text>
          <v-container>
            <v-alert v-if="antes_finalizar === true" outline color="warning" icon="warning" value="true">Antes de finalizar contraste sus datos personales.</v-alert>
                 <div v-if="this.modificacion.mod_codigo === null">
                   <v-layout wrap>
                   <v-flex sm12 md12>
                       <div class="decretosBoton">
                        <v-menu bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" small tile outline color="primary">
                        <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                        </v-btn>
                    </template>
                      <v-card class="px-2 py-1">
                        <v-card-text class="black--text body-2">
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>
                            ATENCIÓN: LOS CAMBIOS QUE REALICE EN ESTE FORMULARIO SE REFLEJARÁN EN SU DECLARACIÓN JURADA.
                          </span>
                        </v-card-text>
                      </v-card>
                      </v-menu>
                      </div>
                    <v-alert class="decretos" :value='true' type='info' outline>ATENCIÓN: LOS CAMBIOS QUE REALICE EN ESTE FORMULARIO SE REFLEJARÁN EN SU DECLARACIÓN JURADA.</v-alert>
                      <v-autocomplete :no-data-text='this.dato' :rules='dRules' return-object v-model='modificacion' :items="itemsMod" item-text="mod_descripcion" item-value="mod_codigo" label="Seleccione el dato a modificar:"></v-autocomplete>
                          <v-layout wrap class="my-2">
                            <v-flex sm6 md6><v-icon>credit_card</v-icon>&nbsp;<b>Número de Documento:</b></v-flex>
                            <v-flex sm6 md6>{{ this.user_c.nro_documento }}</v-flex>
                          </v-layout>
                          <v-layout wrap class="my-2">
                            <v-flex sm6 md6><v-icon>wc</v-icon>&nbsp;<b>Apellido Paterno:</b></v-flex>
                            <v-flex sm6 md6>{{ this.user_c.primer_apellido }}</v-flex>
                          </v-layout>
                          <v-layout wrap class="my-2">
                            <v-flex sm6 md6><v-icon>wc</v-icon>&nbsp;<b>Apellido Materno:</b></v-flex>
                            <v-flex sm6 md6>{{ this.user_c.segundo_apellido }}</v-flex>
                          </v-layout>
                          <v-layout wrap class="my-2">
                            <v-flex sm6 md6><v-icon>supervisor_account</v-icon>&nbsp;<b>Nombres:</b></v-flex>
                            <v-flex sm6 md6>{{ this.user_c.nombres }}</v-flex>
                          </v-layout>
                          <v-layout wrap class="my-2">
                            <v-flex sm6 md6><v-icon>face</v-icon>&nbsp;<b>Género:</b></v-flex>
                            <v-flex sm6 md6>{{ this.itemsGenero[this.user_c.perdec_genero].tipgen_descripcion }}</v-flex>
                          </v-layout>
                          <v-layout wrap class="my-2">
                            <v-flex sm6 md6><v-icon>date_range</v-icon>&nbsp;<b>Fecha de Nacimiento:</b></v-flex>
                            <v-flex sm6 md6>{{ this.formatFechaNacimiento }}</v-flex>
                          </v-layout>
                          <v-layout wrap class="my-2">
                            <v-flex sm6 md6><v-icon>settings_phone</v-icon>&nbsp;<b>Número de Teléfono:</b></v-flex>
                            <v-flex sm6 md6>{{ this.user_c.celular }}</v-flex>
                          </v-layout>
                          <v-layout wrap class="my-2">
                            <v-flex sm6 md6><v-icon>email</v-icon>&nbsp;<b>Correo Electrónico:</b></v-flex>
                            <v-flex sm6 md6>{{ this.user_c.email }}</v-flex>
                          </v-layout>
                    </v-flex>
                </v-layout>   
               </div>
            <div v-if="this.modificacion.mod_codigo === 1">
               <v-form v-model='valid' ref='form' lazy-validation>
                 <v-container>
              <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                <v-select
                    v-model='documentoIdentificacion'
                    :items='itemsDocId'
                    item-text='tipdoc_descripcion'
                    item-value='tipdoc_codigo'
                    :disabled='!modificar'
                    label='Documento de Identificación*'
                    @change='tipoDocumento()'
                    :rules='dRules'
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if='this.documentoIdentificacion===1'>
                <v-flex xs12 sm6 md6>
                  <v-tooltip color="secondary" top>
                    <template v-slot:activator='{ on }'>
                      <v-text-field
                        v-on='on'
                        v-model='nroDocumento'
                        label='Número de Documento*'
                        maxlength='25'
                        :disabled='!modificarNroDoc'
                        :rules='ciRules'                  
                      ></v-text-field>
                    </template>
                  <span>Digite el número del documento de identificación (SIN ESPACIOS VACIOS)</span>
                </v-tooltip>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-tooltip color="secondary" top>
                    <template v-slot:activator='{ on }'>
                      <v-text-field
                        v-on='on'
                        v-model='complemento'
                        :rules='complementoRules'
                        label='Complemento'
                        maxlength='2'
                        :disabled='!modificarComplemento'
                        class="text-normal"
                      ></v-text-field>
                    </template>
                    <span>Complemento alfanumérico otorgado por el SEGIP, por ejemplo "1K", no corresponde a la extensión.</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <div v-if='this.documentoIdentificacion===3'>
                <v-layout wrap>      
                  <v-flex xs12 sm4 md4>
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator='{ on }'>
                          <v-text-field
                            v-on='on'
                            v-model='prefijo'
                            label='Prefijo Alfanumérico Pasaporte*'
                            maxlength='25'                   
                          ></v-text-field>
                        </template>
                        <span>Digite el número de prefijo (SIN ESPACIOS VACIOS)</span>
                    </v-tooltip>  
                  </v-flex>
                  <v-flex xs12 sm4 md4> 
                    <v-tooltip color="secondary" top>
                    <template v-slot:activator='{ on }'>
                      <v-text-field
                        v-on='on'
                        v-model='nroPasaporte'
                        label='Número de Pasaporte*'
                        :disabled='!modificar'
                        maxlength='25'
                        :rules='pasaporteRules'
                      ></v-text-field>
                    </template>
                    <span>Digite el número del pasaporte (SIN ESPACIOS VACIOS) por Ejemplo A-12345</span>
                  </v-tooltip>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator='{ on }'>
                          <v-text-field
                            v-on='on'
                            v-model='sufijo'
                            label='Sufijo Alfanumérico Pasaporte*'
                            maxlength='4'                  
                          ></v-text-field>
                        </template>
                        <span>Digite el número de sufijo (SIN ESPACIOS VACIOS)</span>
                    </v-tooltip>  
                  </v-flex>
                </v-layout>
              </div>
              <v-layout wrap>
                <v-flex xs12 sm12 md6>
                  <v-text-field
                    v-model='apellidoPaterno'
                    label='Apellido Paterno'
                    maxlength='60'
                    :disabled='!modificarPaterno'
                    @keyup="apellidoPaterno = apellidoPaterno ? apellidoPaterno.replace(/[%#{}*]/g, '') : ''"
                    class='my-input'
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-text-field
                    v-model='apellidoMaterno'
                    label='Apellido Materno'
                    maxlength='60'
                    :disabled='!modificarMaterno'
                    @keyup="apellidoMaterno = apellidoMaterno ? apellidoMaterno.replace(/[%#{}*]/g, '') : ''"
                    class='my-input'
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-tooltip color="secondary" top>
                    <template v-slot:activator='{ on }'>
                      <v-text-field
                        v-on='on'
                        v-model='nombres'
                        label='Nombres*'
                        :rules='dRules'
                        required
                        maxlength='100'
                        :disabled='!modificarNombre'
                        @keyup="nombres = nombres ? nombres.replace(/[%#{}*]/g, '') : ''"
                        class='my-input'
                      ></v-text-field>
                    </template>
                    <span>Revise los Apellidos y Nombres que esten transcritos correctamente .</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-select
                  :no-data-text="$t('comun.sin_datos')"
                    v-model='tipoNacionalidad'
                    :items='itemTipoNacionalidad'
                    item-text='tipoNacionalidad_descripcion'
                    item-value='tipoNacionalidad_codigo'
                    label='Nacionalidad*'
                    hint='Dato opcional para validar'
                    persistent-hint
                    teal
                    :rules='dRules'
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <global-date-input-picker
                    v-model="date" :hint="'Formato : DD/MM/AAAA (Dato opcional para validar)'" :disabled='!modificarFechaNac' label="Fecha de Nacimiento*">
                  </global-date-input-picker> 
                </v-flex>
              </v-layout>
              <br />
              <v-layout wrap>
                <b>Digite la letras y/o números que aparecen en la imagen </b>
                <v-layout row wrap>
                  <v-flex md3 offset-md1>
                    <img
                      :src="imgb64"
                      alt="Bolivia">
                  </v-flex>
                  <v-flex md4 offset-md1>
                    <v-text-field
                      v-model="captcha"
                      :rules='this.useCaptcha ? dRules : []'
                      label='Respuesta'
                      :required="this.useCaptcha"
                      :maxlength="this.lengthCaptcha"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md1>
                    <v-icon large @click="crearImagenCaptcha()">cached</v-icon>                  
                  </v-flex>
                </v-layout>  
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-subheader>
                    <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                  </v-subheader>
                </v-flex>
              </v-layout>
                 </v-container>
               </v-form>
               <v-dialog
      v-model="advertencia"
      max-width="290"
    >
      <v-card>
         <v-toolbar dark color="warning" right>
               <v-toolbar-title><h4><v-icon color="error">warning</v-icon>Advertencia</h4></v-toolbar-title>
            </v-toolbar>

        <v-card-text>
         <p align='justify'>Favor verifique que sus datos se encuentren correctos, en caso de tener algún error, favor apersonesé a oficinas de la Contraloría General del Estado
          para la modificación de sus datos.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="advertencia = false"
          ><v-icon>check</v-icon>&nbsp;Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
              </div>
          <div v-if="this.modificacion.mod_codigo === 2">
              <v-icon>face</v-icon>Género Actual:  {{ this.itemsGenero[this.user_c.perdec_genero].tipgen_descripcion }}<br>
              <v-autocomplete :no-data-text='this.dato' return-object v-model='genero' :items="itemsGenero" item-text="tipgen_descripcion" item-value="perdec_genero" label="Seleccione el Género a Modificar:"></v-autocomplete>
          </div>
          <div v-if="this.modificacion.mod_codigo === 3">
            <v-layout row wrap class="mt-2">
              <v-flex xs12 sm6 md6 class="px-1">
                <v-icon small>email</v-icon>&nbsp;Correo Electrónico Actual: <br>  {{ this.user_c.email }}<br> 
                <v-text-field 
                v-model="correoElectronico"
                :rules='emailRules' 
                maxlength='50'
                label="Correo Electrónico Personal"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 class="px-1">
                <v-icon small>settings_phone</v-icon>&nbsp;Número de Teléfono Actual : <br>  {{ this.user_c.celular }}<br>
                <v-text-field v-model="celular"
                  maxlength='8'
                :rules="dRules" label="Teléfono"></v-text-field>
              </v-flex>
            </v-layout>
          <!--   <v-layout row wrap>
              <v-flex sm6 md6>
                <v-text-field 
                v-model="correoElectronico2"
                :rules='emailRules' 
                maxlength='50'
                label="Correo Electrónico Personal 2"></v-text-field>
              </v-flex>
              </v-layout> -->
          </div>
          </v-container>
        </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-if="this.modificacion.mod_codigo === 1"> 
            <div v-if='this.documentoIdentificacion===1'>
                <v-btn color='primary' :loading='loadingContrastar' @click='contrastar()' v-show="this.desabilitaBoton">
                  <v-icon>check</v-icon>&nbsp;Contrastar
                </v-btn> 
                <v-btn color='primary' :loading='loadingModificar' v-show="this.modificarDato" @click='actualizarDatosPersonales()'>
                <v-icon>check</v-icon>&nbsp;Modificar
                </v-btn>
              </div>
            </div>
            <div v-if="this.modificacion.mod_codigo === 2">
              <v-btn color='primary' :loading='loadingGenero' text @click='actualizarDatoGenero()'><v-icon>update</v-icon>&nbsp;Actualizar</v-btn>
            </div>
            <div v-if="this.modificacion.mod_codigo === 3">
            <v-btn color='primary' :loading='loadingContacto' text @click='actualizarDatoContacto()'><v-icon>update</v-icon>&nbsp;Actualizar</v-btn>
            </div>
            <v-btn color="error" text @click='salir(1)'><v-icon>cancel</v-icon>&nbsp;SALIR</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <span>Modificación de datos personales</span>
    </v-tooltip>
    </div>
    <v-menu
      offset-x
      :close-on-content-click="true"
      max-width="320"
      min-width="320"
    >
      <v-btn icon slot="activator">
        <v-avatar size="28" class="info">
          <v-icon color="white">account_circle</v-icon>
        </v-avatar>
      </v-btn>
      <v-card>
        <v-container grid-list-md class="menu-person">
          <v-layout row wrap>
            <v-flex xs3 text-md-center>
              <v-avatar class="info">
                <!-- <span class="white--text headline">{{ inicial }}</span> -->
                <v-icon large color="white">account_circle</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex xs9>
              <span class="title font-weight-regular white--text">{{this.user_c.nombres}} {{this.user_c.primer_apellido}} {{this.user_c.segundo_apellido}}</span>
            </v-flex>
            <!-- <v-flex xs9>
              <h3>{{this.user_c.nombres}} {{this.user_c.primer_apellido}} {{this.user_c.segundo_apellido}}</h3>
              <div v-if="this.user_c.email !== ''">
              <v-icon>mail</v-icon> {{ this.user_c.email }}<br>
              </div>
              <v-icon>person</v-icon> {{ this.user_c.nro_documento }}<br>
            </v-flex> -->
          </v-layout>
          <v-layout row align-center class="mt-2">
            <v-icon>person</v-icon>&nbsp;&nbsp;&nbsp;<span class="font-weight-medium white--text">{{ this.user_c.nro_documento }}</span>
          </v-layout>
          <v-layout row align-center v-if="this.user_c.email !== ''">
            <v-icon>mail</v-icon>&nbsp;&nbsp;&nbsp;<span class="font-weight-medium white--text">{{ this.user_c.email }}</span>
          </v-layout>
        </v-container>
        <v-divider></v-divider>
        <v-list>
          <!-- <v-list-tile @click="$router.push('account')">
            <v-list-tile-title>
              <v-icon>account_circle</v-icon> {{$t('app.account') }}
            </v-list-tile-title>
          </v-list-tile> -->
          <v-list-tile v-if="tipo_usuario === 'usuario_externo' && ingreso === 1" @click.prevent="cambiarContrasenia()">
            <v-list-tile-title>
              <v-icon color="primary">lock</v-icon>&nbsp;Cambiar Contraseña
            </v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile @click.prevent="logout()">
            <v-list-tile-title>
              <v-icon color="secondary">&#xE8AC;</v-icon>&nbsp;{{$t('app.logOut') }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
    <template v-slot:extension>
      <v-tabs 
        color="secondary"
        active-class="tabs-active-class"
        dark
        fixed-tabs
        centered
        show-arrows
        v-show="estado"
        >
        <v-tab @click="changeStep()" to="/declaracion"> <v-icon color="white">home</v-icon>&nbsp;&nbsp;<div class="tab-title white--text">Inicio</div></v-tab>
        <v-tab @click="changeStep()" to="/datos-generales"><v-icon color="white">account_box</v-icon>&nbsp;&nbsp;<div class="tab-title white--text"> Datos generales</div> </v-tab>
        <v-tab @click="changeStep()" to="/bienes"><v-icon color="white">account_balance</v-icon>&nbsp;&nbsp;<div class="tab-title white--text"> Bienes </div> </v-tab>
        <v-tab @click="changeStep()" to="/deudas"><v-icon color="white">money</v-icon>&nbsp;&nbsp;<div class="tab-title white--text">Deudas </div> </v-tab>
        <v-tab @click="changeStep()" to="/parentesco"><v-icon color="white">supervisor_account</v-icon>&nbsp;&nbsp;<div class="tab-title white--text"> Parentesco</div> </v-tab>
        <v-tab v-if="tipo_usuario === 'usuario_externo'" @click="changeStep()" to="/apoderado"><v-icon color="white">&nbsp;&nbsp;&nbsp;gavel</v-icon>&nbsp;&nbsp;<div class="tab-title white--text"> Apoderado</div> </v-tab>
        <v-tab @click="changeStep()" to="/borrador"><v-icon color="white">description</v-icon>&nbsp;&nbsp;<div class="tab-title white--text"> Borrador</div> </v-tab>
        <!-- <v-tab v-if="tipo_usuario !== 'usuario_externo'" @click="changeStep()" to="/transaccion"><v-icon color='primary'>check</v-icon> <div class="tab-title"> Aprobación</div> </v-tab> -->
        <v-tab @click="changeStep()" to="/transaccion"><v-icon color="white">done_all</v-icon>&nbsp;&nbsp;<div class="tab-title white--text"> Finalizar</div> </v-tab>
      </v-tabs>
    </template>
    <v-dialog v-model="dialogContrasenia" max-width="690" persistent>
      <v-card>
         <v-toolbar dark color="primary" right>
               <v-toolbar-title><h4><v-icon class="mt-1" color="info">lock</v-icon>&nbsp;Cambiar Contraseña</h4></v-toolbar-title>
            </v-toolbar>
        <v-card-text>
         <p align='justify'>Por favor Digite su contraseña: </p>
          <v-form :v-model='true' ref='formContrasenia' lazy-validation>
            <v-layout row wrap>
              <v-flex md12 offset-md0>
                <v-text-field
                  v-model="contrasenia_validar"
                  label='Ingrese Contraseña Actual*'
                  :rules="dRules"
                  required
                  prepend-icon="security"
                  :append-icon="showPassValidar ? 'visibility' : 'visibility_off'"
                  :type="showPassValidar ? 'password' : 'text'"
                  maxlength="100"
                  @click:append="() => (showPassValidar = !showPassValidar)"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
                  <v-flex md12 offset-md0>
                    <v-text-field
                      v-model="contrasenia"
                      label='Nueva Contraseña*'
                      :rules='passRule'
                      required
                      prepend-icon="security"
                      :append-icon="showPass ? 'visibility' : 'visibility_off'"
                      :type="showPass ? 'password' : 'text'"
                      maxlength="100"
                      @click:append="() => (showPass = !showPass)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md12 offset-md0>
                    <v-text-field
                      v-model="contrasenia_repetir"
                      label='Repetir Contraseña*'
                      :rules='passRule'
                      required
                      prepend-icon="security"
                      :append-icon="showPassRepetir ? 'visibility' : 'visibility_off'"
                      :type="showPassRepetir ? 'password' : 'text'"
                      maxlength="100"
                      @click:append="() => (showPassRepetir = !showPassRepetir)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="loadingButton" text @click="cambioContrasenia()"><v-icon>autorenew</v-icon>&nbsp;Cambiar</v-btn>
          <v-btn color="error" text @click="cancelaDialogContrasenia()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>

<script>
import Captcha from '../../components/portal/mixins/captcha.js';
import Auth from '@/components/admin/auth/mixins/auth';
import AppLang from './AppLang';
import { mapState } from 'vuex';
import Parametricas from '@/components/djbrd/mixins/parametricas';
import Segip from '../../components/djbrd/mixins/segip.js';

export default {
  mounted () {
    this.$root.$on('clickedSomething', () => {
      this.obtenerEstadoDeclaracion().then(respuesta => {
        if (respuesta.finalizado) {
          if (respuesta.data.cod_estado === 3) {
            this.habilitar_edicion = true;
            this.estado = false;
          }
          if (respuesta.data.cod_estado === 2) {
            this.habilitar_edicion = false;
            this.estado = false;
          }
          if (respuesta.data.cod_estado === -1) {
            this.habilitar_edicion = true;
            this.estado = false;
          }
          if (respuesta.data.cod_estado === 1) {
            this.habilitar_edicion = true;
            this.estado = true;
          }
        }
      });
    });
    this.$root.$on('clickedSegip', () => {
      this.modificacion.mod_codigo = 1;
      this.dialog = true;
      this.antes_finalizar = true;
    });
  },
  created () {
    this.user_c = this.$storage.get('user');
    this.ingreso = this.$storage.get('ingreso');
    if (this.user_c.email.indexOf('|') !== -1) {
      var str = this.user_c.email;
      var res = str.split('|');
      this.user_c.email = res[0];
      this.$storage.set('user', this.user_c);
    }
    let token = this.$util.parseJwt(this.$storage.get('token'));
    this.tipo_usuario = token.tipo;
    this.obtieneTipoDocumento();
    if (this.tipo_usuario === 'usuario_externo') {
      this.setearDatos();
    }
    this.obtenerEstadoDeclaracion().then(respuesta => {
      if (respuesta.finalizado) {
        if (respuesta.data.cod_estado === 3) {
          this.habilitar_edicion = true;
          this.estado = false;
        }
        if (respuesta.data.cod_estado === 2) {
          this.habilitar_edicion = false;
          this.estado = false;
        }
        if (respuesta.data.cod_estado === -1) {
          this.habilitar_edicion = true;
          this.estado = false;
        }
        if (respuesta.data.cod_estado === 1) {
          this.habilitar_edicion = true;
          this.estado = true;
        }
      }
    });
    this.crearImagenCaptcha();
  },
  mixins: [ Segip, Auth, Parametricas, Captcha ],
  data: () => ({
    enviroment: process.env.ENVIROMENT,
    ingreso: 0,
    habilitar_edicion: true,
    antes_finalizar: false,
    loadingContrastar: false,
    loadingModificar: false,
    loadingGenero: false,
    loadingContacto: false,
    advertencia: false,
    nroDocumento: '',
    desabilitaBoton: true,
    modificarDato: false,
    complemento: '',
    documentoIdentificacion: '',
    itemsDocId: null,
    nroPasaporte: '',
    nroCiPasaporte: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    nombres: '',
    sufijo: '',
    prefijo: '',
    tipoNacionalidad: 0,
    itemTipoNacionalidad: [
      {
        tipoNacionalidad_descripcion: 'NACIONAL',
        tipoNacionalidad_codigo: '1'
      },
      {
        tipoNacionalidad_descripcion: 'EXTRANJERO',
        tipoNacionalidad_codigo: '2'
      }
    ],
    ciRules: [
      v => !!v || 'Este campo es requerido ci',
      v => /^[0-9]*$/.test(v) || 'El número de ci no es válido'
    ],
    complementoRules: [
      v => (!/^[CH]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[LP]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[CB]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[OR]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PT]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[TJ]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[SC]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[BN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición'
    ],
    pasaporteRules: [
      v => !!v || 'Este campo es requerido pasaporte',
      v =>
        /^[A-Za-z0-9]{1,4}-[0-9]{1,10}$/.test(v) ||
        'El número de pasaporte no es válido'
    ],
    emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Si ingresa un correo verifique que sea uno válido'],
    correoElectronico: '',
    correoElectronico2: '',
    celular: '',
    menu: false,
    date: '',
    estado: false,
    clipped: false,
    user_c: null,
    tipo_usuario: '',
    valid: true,
    stepper: 0,
    mycolor: '#000000',
    dialog: false,
    genero: { perdec_genero: null, tipgen_descripcion: '' },
    dato: 'Dato no encontrado',
    modificar: false,
    modificarPaterno: false,
    modificarMaterno: false,
    modificarNombre: false,
    modificarFechaNac: false,
    modificarNroDoc: false,
    modificarComplemento: false,
    modificaDocumento: null,
    dRules: [v => !!v || 'Esta información es requerida'],
    segipContrastacion: {
      Complemento: 1,
      ComplementoVisible: 1,
      FechaNacimiento: 1,
      Nombres: 1,
      NumeroDocumento: 1,
      PrimerApellido: 1,
      SegundoApellido: 1
    },
    itemsMod: [
      { mod_codigo: 1, mod_descripcion: 'DATOS PERSONALES' },
      { mod_codigo: 2, mod_descripcion: 'GÉNERO' },
      { mod_codigo: 3, mod_descripcion: 'DATOS CONTACTO' }],
    modificacion: { mod_codigo: null, mod_descripcion: '' },
    itemsGenero: [
      {
        perdec_genero: 0,
        tipgen_descripcion: 'FEMENINO'
      },
      {
        perdec_genero: 1,
        tipgen_descripcion: 'MASCULINO'
      }
    ],
    captcha: '',
    imgb64: '',
    tokenCaptcha: '',
    useCaptcha: process.env.USE_CAPTCHA,
    lengthCaptcha: process.env.LENGTH_CAPTCHA,
    dialogContrasenia: false,
    passRule: [v => /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W_]){1,})(?!.*\s).{8,}$/.test(v) || 'Debe tener al menos 8 caracteres, una letra mayúscula (A-Z), minúscula (a-z), un número (0-9) y un caracter especial, por ejemplo ( @ # $ % ^ & * ç )'],
    contrasenia_validar: '',
    contrasenia: '',
    contrasenia_repetir: '',
    showPassValidar: true,
    showPass: true,
    showPassRepetir: true,
    loadingButton: false
  }),
  methods: {
    cambioContrasenia () {
      if (this.$refs.formContrasenia.validate()) {
        if (this.contrasenia === this.contrasenia_repetir) {
          this.loadingButton = true;
          let params = {
            cuefundec_contrasenia0: this.contrasenia_validar,
            cuefundec_contrasenia: this.contrasenia,
            cuefundec_contrasenia2: this.contrasenia_repetir
          };
          this.$service.put(`control_tarjeta/reset_password_usuario`, params).then(response => {
            if (response.err_existente === 0) {
              this.$message['success'](response.err_mensaje);
              this.cancelaDialogContrasenia();
            }
          }).catch(err => {
            console.log(err);
            this.loadingButton = false;
          });
        } else {
          this.$message['warning']('Las contraseñas no coinciden, favor verificar');
        }
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    cancelaDialogContrasenia () {
      this.dialogContrasenia = false;
      this.contrasenia = '';
      this.contrasenia_repetir = '';
      this.contrasenia_validar = '';
      this.loadingButton = false;
      this.$refs.formContrasenia.resetValidation();
    },
    cambiarContrasenia () {
      this.dialogContrasenia = true;
    },
    fullscreen () {
      document.querySelector('body').classList.toggle('fullscreen');
      this.$util.fullscreen();
    },
    showMessage (type, men) {
      this.$message[type](`${men}`);
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    tipoDocumento () {
      if (this.documentoIdentificacion === 1) {
        this.nroDocumento = this.nroPasaporte;
        this.nroPasaporte = '';
      } else {
        this.nroPasaporte = this.nroDocumento;
        this.nroDocumento = '';
      }
    },
    obtieneTipoDocumento () {
      this.$service.get('tipos_documentos', {}).then(res => {
        if (res) {
          this.itemsDocId = res;
        }
      });
    },
    setearDatos () {
      this.documentoIdentificacion = this.user_c.tipo_documento;
      var str = this.user_c.perdec_docidentidad;
      var res = str.split('_');
      this.nroDocumento = res[1];
      this.complemento = res[2];
      this.apellidoPaterno = this.user_c.primer_apellido;
      this.apellidoMaterno = this.user_c.segundo_apellido;
      this.nombres = this.user_c.nombres;
      this.date = this.$util.formatDateDDMMYYYY(this.formatFechaNacimiento);
    },
    salir (tipo) {
      if (this.modificacion.mod_codigo === 1) {
        this.$refs.form.resetValidation();
      }
      this.dialog = false;
      this.correoElectronico = '';
      this.celular = '';
      this.modificacion = { mod_codigo: null, mod_descripcion: '' };
      this.genero = { perdec_genero: null, tipgen_descripcion: '' };
      this.desabilitaBoton = true; // boton contrastar
      this.modificarDato = false; // boton modificar
      this.modificarPaterno = false;
      this.modificarMaterno = false;
      this.modificarNombre = false;
      this.modificarFechaNac = false;
      this.modificarNroDoc = false;
      this.modificarComplemento = false;
      this.tokenCaptcha = '';
      this.captcha = '';
      this.StorageEmmit();
      if (tipo !== 1) {
        this.crearImagenCaptcha();
        this.guardarDatosPersonalesEmmit();
      }
      this.loadingContrastar = false;
      this.loadingModificar = false;
      this.loadingGenero = false;
      this.loadingContacto = false;
      this.antes_finalizar = false;
    },
    async actualizarDatosPersonales () {
      if (this.$refs.form.validate()) {
        this.loadingModificar = true;
        let params = {
          tipo_persona: this.tipoNacionalidad,
          NumeroDocumento: this.nroDocumento,
          FechaNacimiento: this.date,
          PrimerApellido: this.apellidoPaterno,
          SegundoApellido: this.apellidoMaterno,
          nombres: this.nombres,
          token: this.tokenCaptcha,
          captcha: this.captcha
        };
        if (this.complemento !== '') {
          params.NumeroDocumento = `${this.nroDocumento}-${this.complemento}`;
        }
        let responseSegip = await this.contrastarSegip(params).then(resp => {
          if (resp.err_existente === 0) {
            this.$message['success'](resp.err_mensaje);
            resp.finalizado = true;
          }
          if (resp.err_existente === 1) {
            this.$message['info'](resp.err_mensaje);
            resp.finalizado = false;
          }
          return resp;
        }).catch(e => {
          console.log(e);
          this.loadingModificar = false;
          return e;
        });
        // this.segipContrastacion = responseSegip.camposComparados;
        // let estadoSegip = responseSegip.estadoSegip ? responseSegip.estadoSegip : true;
        if (responseSegip.finalizado === true) {
          this.$storage.remove('user');
          if (this.modificaDocumento === 0) {
            this.$service.put(`djbr_registro/datos_declarante`, [{valor_actual_prefijo: '', valor_actual_numero_documento: this.nroDocumento, valor_actual_sufijo: this.complemento, valor_actual_tipo_documento: this.documentoIdentificacion, tipo_modificacion: 'DOC', relacion: 0, prefijo_pasaporte: '', nro_pasaporte: '', sufijo_pasaporte: ''}]).then(response => {
              if (response) {
                if (response.error_existente === 0) {
                  this.user_c.nro_documento = this.numeroDocumento.toUpperCase();
                  this.$storage.set('user', this.user_c);
                  this.$message['success'](response.err_mensaje);
                  this.loadingModificar = false;
                  this.modificacion = { mod_codigo: null, mod_descripcion: '' };
                  this.modificarNroDoc = false;
                  this.modificarComplemento = false;
                  this.desabilitaBoton = true; // boton contrastar
                  this.modificarDato = false; // boton modificar
                } else {
                  this.$message['error'](response.error_mensaje);
                  this.modificacion = { mod_codigo: null, mod_descripcion: '' };
                  this.loadingModificar = false;
                }
              } else {
                this.crearImagenCaptcha();
                this.loadingModificar = false;
              }
            });
          }
          if (this.segipContrastacion.PrimerApellido === 0 || this.segipContrastacion.PrimerApellido === 2) {
            this.$service.put(`djbr_registro/datos_declarante`, [{valor_actual: this.apellidoPaterno, tipo_modificacion: 'MAP'}]).then(response => {
              if (response) {
                if (response.error_existente === 0) {
                  this.user_c.primer_apellido = this.apellidoPaterno.toUpperCase();
                  this.$storage.set('user', this.user_c);
                  this.$message['success'](response.err_mensaje);
                  this.loadingModificar = false;
                  this.modificacion = { mod_codigo: null, mod_descripcion: '' };
                  this.modificarPaterno = false;
                  this.desabilitaBoton = true; // boton contrastar
                  this.modificarDato = false; // boton modificar
                } else {
                  this.$message['error'](response.error_mensaje);
                  this.modificacion = { mod_codigo: null, mod_descripcion: '' };
                  this.loadingModificar = false;
                }
              } else {
                this.crearImagenCaptcha();
                this.loadingModificar = false;
              }
            });
          }
          if (this.segipContrastacion.SegundoApellido === 0 || this.segipContrastacion.SegundoApellido === 2) {
            this.$service.put(`djbr_registro/datos_declarante`, [{valor_actual: this.apellidoMaterno, tipo_modificacion: 'MAM'}]).then(response => {
              if (response) {
                if (response.error_existente === 0) {
                  this.user_c.segundo_apellido = this.apellidoMaterno.toUpperCase();
                  this.$storage.set('user', this.user_c);
                  this.$message['success'](response.err_mensaje);
                  this.loadingModificar = false;
                  this.modificacion = { mod_codigo: null, mod_descripcion: '' };
                  this.modificarMaterno = false;
                  this.desabilitaBoton = true; // boton contrastar
                  this.modificarDato = false; // boton modificar
                } else {
                  this.$message['error'](response.error_mensaje);
                  this.loadingModificar = false;
                  this.modificacion = { mod_codigo: null, mod_descripcion: '' };
                }
              } else {
                this.loadingModificar = false;
              }
            });
          }
          if (this.segipContrastacion.Nombres === 0) {
            this.$service.put(`djbr_registro/datos_declarante`, [{valor_actual: this.nombres, tipo_modificacion: 'MNP'}]).then(response => {
              if (response) {
                if (response.error_existente === 0) {
                  this.user_c.nombres = this.nombres.toUpperCase();
                  this.$storage.set('user', this.user_c);
                  this.$message['success'](response.err_mensaje);
                  this.loadingModificar = false;
                  this.modificacion = { mod_codigo: null, mod_descripcion: '' };
                  this.modificarNombre = false;
                  this.desabilitaBoton = true; // boton contrastar
                  this.modificarDato = false; // boton modificar
                } else {
                  this.$message['error'](response.error_mensaje);
                  this.loadingModificar = false;
                  this.modificacion = { mod_codigo: null, mod_descripcion: '' };
                }
              } else {
                this.loadingModificar = false;
              }
            });
          }
          if (this.segipContrastacion.FechaNacimiento === 0) {
            this.$service.put(`djbr_registro/datos_declarante`, [{valor_actual: this.date, tipo_modificacion: 'MFN'}]).then(response => {
              if (response) {
                if (response.error_existente === 0) {
                  this.user_c.fecha_nacimiento = this.parseDate(this.date);
                  this.$storage.set('user', this.user_c);
                  this.$message['success'](response.err_mensaje);
                  this.loadingModificar = false;
                  this.modificacion = { mod_codigo: null, mod_descripcion: '' };
                  this.modificarFechaNac = false;
                  this.desabilitaBoton = true; // boton contrastar
                  this.modificarDato = false; // boton modificar
                } else {
                  this.$message['error'](response.error_mensaje);
                  this.loadingModificar = false;
                  this.modificacion = { mod_codigo: null, mod_descripcion: '' };
                }
              } else {
                this.loadingModificar = false;
              }
            });
          }
        } else {
          this.loadingModificar = false;
          this.desabilitaBoton = false; // boton contrastar
          this.modificarDato = true; // boton modificar
          this.crearImagenCaptcha();
          if (this.segipContrastacion.PrimerApellido === 0) {
            this.modificarPaterno = true;
          }
          if (this.segipContrastacion.SegundoApellido === 0) {
            this.modificarMaterno = true;
          }
          if (this.segipContrastacion.Nombres === 0) {
            this.modificarNombre = true;
          }
          if (this.segipContrastacion.FechaNacimiento === 0) {
            this.modificarFechaNac = true;
          }
        }
      } else {
        this.$message['warning']('Favor Ingrese los Datos Obligatorios.');
      }
    },
    actualizarDatoGenero () {
      this.loadingGenero = true;
      this.$storage.remove('user');
      if (this.genero.perdec_genero === null) {
        this.$message['warning']('Debe añadir el género a modificar');
        this.loadingGenero = false;
      } else {
        this.$service.post(`djbr_registro/actualiza_datos_declarante`, {valor_actual: this.genero.perdec_genero, tipo_modificacion: 'MGP'}).then(response => {
          if (response) {
            if (response.err_existente === 0) {
              this.user_c.perdec_genero = this.genero.perdec_genero;
              this.$storage.set('user', this.user_c);
              this.$message['success'](response.err_mensaje);
              this.loadingGenero = false;
              this.modificacion = { mod_codigo: null, mod_descripcion: '' };
            } else {
              this.$message['error'](response.err_mensaje);
              this.loadingGenero = false;
              this.modificacion = { mod_codigo: null, mod_descripcion: '' };
            }
          } else {
            this.loadingGenero = false;
          }
        }).catch(e => {
          console.log(e);
          this.loadingGenero = false;
        });
      }
    },
    actualizarDatoContacto () {
      this.loadingContacto = true;
      this.$storage.remove('user');
      if (this.correoElectronico === '') {
        this.correoElectronico = this.user_c.email;
      }
      if (this.celular === '') {
        this.$message['warning']('El valor Teléfono es requerido');
        this.loadingContacto = false;
      } else {
        this.$service.post(`djbr_registro/actualiza_datos_declarante`, {tipo_modificacion: 'MDC', celular: this.celular, correo1: this.correoElectronico, correo2: this.correoElectronico2}).then(response => {
          if (response) {
            if (response.err_existente === 0) {
              this.user_c.celular = this.celular;
              this.user_c.email = this.correoElectronico;
              this.$storage.set('user', this.user_c);
              this.$message['success'](response.err_mensaje);
              this.loadingContacto = false;
              this.modificacion = { mod_codigo: null, mod_descripcion: '' };
            } else {
              this.$message['error'](response.err_mensaje);
              this.loadingContacto = false;
              this.modificacion = { mod_codigo: null, mod_descripcion: '' };
            }
          } else {
            this.loadingContacto = false;
          }
        }).catch(e => {
          console.log(e);
          this.loadingContacto = false;
        });
      }
    },
    changeStep () {
      let ctrl = this.$storage.get('ctrl');
      if (ctrl.datos_generales.datos_declaracion) {
        this.$message['warning']('Datos de la Declaración, se estaban editando pero NO SE HA GUARDADO.');
        let ctrl = this.$storage.get('ctrl');
        ctrl.datos_generales.datos_declaracion = false;
        this.$storage.set('ctrl', ctrl);
      }
      if (ctrl.datos_generales.datos_personales) {
        this.$message['warning']('Datos Personales, se estaba editando pero NO SE HA GUARDADO.');
        let ctrl = this.$storage.get('ctrl');
        ctrl.datos_generales.datos_personales = false;
        this.$storage.set('ctrl', ctrl);
      }
      if (ctrl.datos_generales.cargo_ocupara) {
        this.$message['warning']('Cargo que Ocupará, se estaba editando pero NO SE HA GUARDADO.');
        let ctrl = this.$storage.get('ctrl');
        ctrl.datos_generales.cargo_ocupara = false;
        this.$storage.set('ctrl', ctrl);
      }
      if (ctrl.datos_generales.conyuge) {
        this.$message['warning']('Conyuge, se estaba editando pero NO SE HA GUARDADO.');
        let ctrl = this.$storage.get('ctrl');
        ctrl.datos_generales.conyuge = false;
        this.$storage.set('ctrl', ctrl);
      }
    },
    async contrastar () {
      if (this.complemento === 'LP' || this.complemento === 'CB' || this.complemento === 'SC' ||
          this.complemento === 'PT' || this.complemento === 'OR' || this.complemento === 'CH' ||
          this.complemento === 'TJ' || this.complemento === 'BN' || this.complemento === 'PN') {
        this.$message['warning']('El complemento no es un departamento de expedición, el complemento puede ser por ejemplo 1234567-1j');
        this.complemento = '';
        this.modificarNroDoc = true;
        this.modificarComplemento = true;
        this.desabilitaBoton = false; // boton contrastar
        this.modificarDato = true; // boton modificar
        this.modificaDocumento = 0;
      }
      if (!(!!this.apellidoPaterno || !!this.apellidoMaterno)) {
        this.$message['warning']('Al menos uno de los apellidos es requerido');
      }
      if (this.$refs.form.validate()) {
        this.loadingContrastar = true;
        // let verify = this.verificarCaptcha(this.useCaptcha, this.tokenCaptcha, this.captcha);
        // if (verify) {
        let params = {
          tipo_persona: this.tipoNacionalidad,
          NumeroDocumento: this.nroDocumento,
          FechaNacimiento: this.date,
          PrimerApellido: this.apellidoPaterno,
          SegundoApellido: this.apellidoMaterno,
          nombres: this.nombres,
          token: this.tokenCaptcha,
          captcha: this.captcha
        };
        if (this.complemento !== '') {
          params.NumeroDocumento = `${this.nroDocumento}-${this.complemento}`;
        }
        let responseSegip = await this.contrastarSegip(params).then(resp => {
          if (resp.err_existente === 0) {
            this.$message['success'](resp.err_mensaje);
            resp.finalizado = true;
          }
          if (resp.err_existente === 1) {
            this.$message['info'](resp.err_mensaje);
            resp.finalizado = false;
          }
          return resp;
        });
        this.segipContrastacion = responseSegip.camposComparados;
        let estadoSegip = responseSegip.estadoSegip ? responseSegip.estadoSegip : true;
        if (estadoSegip) {
          if (responseSegip.finalizado) {
          // this.$message[responseSegip.tipo](responseSegip.mensaje[0]);
            this.$service.put(`djbr_registro/contrastacion_segip`).then(response => {
              if (response) {
                this.$message['success']('Los datos se encuentran correctos no se tiene ningún registro para modificar');
                this.loadingContrastar = false;
                this.salir();
                this.user_c.segip = 1;// //////cambiarrrrrr
                this.$storage.set('user', this.user_c);// //////cambiarrrrrr
              }
            }).catch(e => {
              console.log(e);
              this.loadingContrastar = false;
            });
            if (this.segipContrastacion.PrimerApellido === 2) {
              this.modificarPaterno = true;
              this.desabilitaBoton = false; // boton contrastar
              this.modificarDato = true; // boton modificar
              this.loadingContrastar = false;
            }
            if (this.segipContrastacion.SegundoApellido === 2) {
              this.modificarMaterno = true;
              this.desabilitaBoton = false; // boton contrastar
              this.modificarDato = true; // boton modificar
              this.loadingContrastar = false;
            }
          } else {
            this.loadingContrastar = false;
            this.crearImagenCaptcha();
            if (responseSegip.mensaje) {
              responseSegip.mensaje.forEach(msj => {
                this.$message[responseSegip.tipo](msj);
                if (msj === 'No se encontró el registro') {
                  this.advertencia = true;
                }
              });
            }
            if (this.segipContrastacion && this.segipContrastacion.PrimerApellido === 0) {
              this.modificarPaterno = true;
              this.desabilitaBoton = false; // boton contrastar
              this.modificarDato = true; // boton modificar
            }
            if (this.segipContrastacion && this.segipContrastacion.SegundoApellido === 0) {
              this.modificarMaterno = true;
              this.desabilitaBoton = false; // boton contrastar
              this.modificarDato = true; // boton modificar
            }
            if (this.segipContrastacion && this.segipContrastacion.Nombres === 0) {
              this.modificarNombre = true;
              this.desabilitaBoton = false; // boton contrastar
              this.modificarDato = true; // boton modificar
            }
            if (this.segipContrastacion && this.segipContrastacion.FechaNacimiento === 0) {
              this.modificarFechaNac = true;
              this.desabilitaBoton = false; // boton contrastar
              this.modificarDato = true; // boton modificar
            }
          }
        } else {
          this.$message['info'](responseSegip.mensaje);
          this.$message['info']('La modificación de datos debe hacerlo más tarde');
          this.loadingContrastar = false;
          this.desabilitaBoton = true; // boton contrastar
          this.modificarDato = false; // boton modificar
          this.salir();
        }
        // } else {
        //   this.crearImagenCaptcha();
        //   this.$message['warning']('El código ingresado no es correcto');
        //   this.loadingContrastar = false;
        //   this.respuesta.estado = '';
        // }
      } else {
        this.$message['warning']('Favor Ingrese los Datos Obligatorios.');
      }
    },
    async crearImagenCaptcha () {
      this.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    }
  },
  components: { AppLang },
  computed: {
    ...mapState(['user']),
    nombreCompleto () {
      let user = this.$store.state.user;
      return user.nombres;
    },
    formatFechaNacimiento () {
      if (!this.user_c.fecha_nacimiento) return null;
      const [year, month, day] = this.user_c.fecha_nacimiento.split('-');
      return `${day}/${month}/${year}`;
    },
    inicial () {
      if (this.user_c.nombres) {
        const colors = ['purple', 'pink', 'purple darken-1', 'red darken-1', 'pink accent-3', 'indigo', 'blue darken-2', 'light-blue', 'cyan', 'teal', 'lime', 'light-green', 'green', 'orange', 'amber', 'amber darken-4', 'orange accent-4', 'blue-grey', 'brown', 'deep-orange', 'pink darken-1', 'pink darken-4', 'red darken-1', 'red accent-3', 'deep-purple', 'deep-purple darken-1', 'deep-purple accent-2', 'purple darken-1', 'purple darken-3', 'blue darken-1', 'blue accent-3', 'blue darken-1', 'indigo darken-1', 'indigo accent-3', 'cyan darken-1', 'cyan lighten-1', 'light-blue darken-2', 'light-blue darken-4', 'light-blue accent-3', 'green darken-3', 'green lighten-1', 'teal darken-2', 'teal darken-4', 'lime darken-2', 'light-green darken-2', 'amber lighten-1', 'amber darken-3', 'yellow darken-3', 'yellow accent-4', 'deep-orange darken-3', 'deep-orange darken-1', 'orange lighten-1', 'blue-grey lighten-1', 'blue-grey lighten-2', 'brown darken-3'];
        this.mycolor = colors[Math.floor(Math.random() * (54))];
        return (this.user_c.nombres[0] || '?').toUpperCase();
      }
      return '?';
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';
.warning-band {
  background-image:
    repeating-linear-gradient(
      135deg,
      gold,
      gold 15px,
      black 15px,
      black 30px /* determines size */
    );
}
.app-navbar {
  box-shadow: 0px 1px 15px 1px rgba(69, 65, 78, 0.1);

  .v-toolbar__content {
    padding: 0 15px;
  }

  .v-btn .v-icon {
    color: $color;
  }

  .menu-user {
    margin-right: 10px;
    .v-toolbar__title {
      font-size: 16px;
      color: $color;
    }
    .v-icon {
      font-size: 40px;
    }
  }
  
  .btn-mini-variant {
    display: inline-block;
  }
  .btn-drawer {
    display: none;
  }

}

.btn-fullscreen {
  .v-icon:last-child {
    display: none;
  }
}

body.fullscreen {
  .btn-fullscreen {
    .v-icon:first-child {
      display: none;
    }
    .v-icon:last-child {
      display: inline-block;
    }
  }
}

.v-tabs__item:not(.v-tabs__item--active) {
  opacity: 1!important;
}

.tabs-active-class{
  background-color: lighten($primary, 0%)!important;
  border-bottom: 3px solid darken($accent, 0%)!important;
  .tab-title {
    color: white !important;
  }
}

.menu-person {
  color: lighten($warning, 10%);
  font-size: 1rem;
  padding: 10px 15px;
  background-color: darken($primary, 10%);
  background-position: center;
  background-size: cover;

  h3 {
    font-size: 1.3rem;
    color: white;
    font-weight: 400;
  }

  .v-icon {
    color: white !important;
    font-size: 1.1rem;
  } 
}
div.v-toolbar__extension {
  background-color: $secondary!important;
}
@media (max-width: 1256px) {
  .app-navbar {
    .btn-mini-variant {
      display: none;
    }
    .btn-drawer {
      display: inline-block;
    }
  }
}
.icon-flag {
  width: 150px!important;
  height: 50px!important;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
  background-size: cover;
  background-repeat: no-repeat;

  &.logo {
    background-image: url(../../assets/images/logo_azul.png);
  }
}
.application .v-toolbar .btn-lang {
  color: rgba(0,0,0,0.87);
}
.tab-title {
  color: black;
}
@media (max-width: 600px) {
  .tab-title {
    display: none;
  }
  .icon-flag {
    width: 40px!important;
    height: 45px!important;
    display: inline-block;
    margin-right: 0px;
    vertical-align: middle;
    background-size: cover;
    background-repeat: no-repeat;

    &.logo {
      background-image: url(../../assets/images/logo_azul.png);
    }
  }
  .btn-fullscreen {
    display: none;
  }
  .btn-recargar-pagina {
    display: none;
  }
}
.my-input input {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/common/layout/AppNavbar.vue